
import './css/mycss.css';
import { Cards } from './Cards.js';
import img1 from './images/z1.png';
import img2 from './images/z2.png';
import img3 from './images/z3.png';
import img4 from './images/z4.png';
export function CardDisplay2()
{
    return(
        <div className="divcss3">
        <div className='divcss4'>
        <Cards htext="Bharat Ratna" 
        ptext="Awarded for exceptional service or performance of the highest order in any field." 
        img1={img1} 
        btext="learn more"
        modalContent={`
  <b>Established:</b> 2 January 1954<br/>
  <b>Type:</b> Highest civilian award of India</br>
  <b>First Awarded:</b>1954</br>
  <b>First Recipient:</b>C. Rajagopalachari, Dr. Sarvepalli Radhakrishnan, and Dr. C. V. Raman</br>
  <b>Material:</b>Bronze</br>
  <b>Symbolism:</b>Sun and peepal leaf represent knowledge, enlightenment, and national service at the highest level.</br>
  <b>Awarded For:</b> Exceptional service or performance of the highest order in any field of human endeavor, including public service, art, science, and sports.</br>
  <br/><a href='https://en.wikipedia.org/wiki/Bharat_Ratna'>wiki link</a>
`}

        />
        <Cards htext="Padma Vibhushan" 
        ptext="Awarded for exceptional and distinguished service in any field." 
        img1={img2} 
        btext="learn more"
        modalContent={`
  <b>Established:</b> 2 January 1954 <br/>
  <b>Type:</b> Second‑highest civilian award</br>
  <b>First Awarded:</b>1954</br>
  <b>First Recipient:</b>Satyendra Nath Bose, Nandalal Bose, Zakir Hussain</br>
  <b>Material:</b> Bronze</br>
  <b>Symbolism:</b>Lotus and emblem denote exceptional and distinguished service to the nation.</br>
  <b>Awarded For:</b>Exceptional and distinguished service” in any field, including government service.</br>
  <br/><a href='https://en.wikipedia.org/wiki/Padma_Vibhushan'>wiki link</a>
`}
/>
        <Cards htext="Padma Bhushan" 
        ptext="Awarded for distinguished service of a high order in any field." 
        img1={img3} 
        btext="learn more"
        modalContent={`
  <b>Established:</b> 2 January 1954 <br/>
  <b>Type:</b>Third‑highest civilian award</br>
  <b>First Awarded:</b> 1954</br>
  <b>First Recipient:</b>A. Lakshmanaswami Mudaliar, Shanti Swaroop Bhatnagar and V. Ramaswami</br>
  <b>Material:</b> Bronze</br>
  <b>Symbolism:</b>Lotus symbolizes high‑order contribution and purity of service.</br>
  <b>Awarded For:</b> Distinguished service of a high order in any field, including public affairs.</br>
  <br/><a href='https://en.wikipedia.org/wiki/Padma_Bhushan'>wiki link</a>
`}
/>
        <Cards htext="Padma Shri" 
        ptext="The Padma Shri is awarded for distinguished service in any field." 
        img1={img4} 
        btext="learn more"
        modalContent={`
  <b>Established:</b>2 January 1954<br/>
  <b>Type:</b> Fourth‑highest civilian award</br>
  <b>First Awarded:</b>1954</br>
  <b>First Recipient:</b>Bir Bhan Bhatia,Perin Captain,K. R. Chakravorty and Amalprava Das</br>
  <b>Material:</b> Bronze</br>
  <b>Symbolism:</b>Represents recognition of distinguished contribution to society in diverse fields.</br>
  <b>Awarded For:</b>Distinguished service in any field, including social work, medicine, education, literature, sports, and public affairs.</br>
  <br/><a href='https://en.wikipedia.org/wiki/Padma_Shri'>wiki link</a>
`}
/>
        </div>
        
        </div>
        
    );
}